if (!customElements.get('banner-cards')) {
  customElements.define(
    'banner-cards',
    class BannerCards extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.videos = [...this.querySelectorAll('[data-d-bc-video]')];
        if (!this.videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        if (!('IntersectionObserver' in window)) {
          this.videos.forEach((video) => this.loadAndPlay(video));
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                this.loadAndPlay(video);
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.1 }
        );

        this.videos.forEach((video) => this.observer.observe(video));
        this.addEventListener('shopify:block:select', (event) => {
          const video = event.target.querySelector('[data-d-bc-video]');
          if (video) this.loadAndPlay(video);
        });
      }

      loadAndPlay(video) {
        if (video.dataset.loaded !== 'true') {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.dataset.loaded = 'true';
          video.load();
        }

        video.play().catch(() => {});
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
